import React from 'react';
import { Link } from 'react-router-dom';
import { useProduct } from './contexts/product-ctx';
import YouTubeWrapper from './components/YouTubeWrapper';
import Footer from './components/Footer';

import { Box, Text, Image, Button } from '@chakra-ui/react';
import { getMenuImageUrl, getMenuImagePlaceholderUrl } from './utils/menuImageUrl';

// PRODUCT CAN BE A PRODUCT OR A MENU
function ProductDetail() {
  const { product } = useProduct();
console.log('ProductDetail', product)

  if (!product) return null;

  const kind = product.products ? 'combo' : 'product';
  return (
    <Box w={'100%'} color='white' mt={5} bg='#3c4d5f' textAlign={'center'}>
      <Text fontSize={'4xl'}>{product.title}</Text>
      <Image
        border='2px solid grey'
        borderRadius={5}
        m='auto'
        my={35}
        // w='50%'
        // fallbackSrc={placeholder}
        fallbackSrc={getMenuImagePlaceholderUrl()}
        w={'300px'}
        src={getMenuImageUrl({
          imageId: product.imageId,
          id: product.id,
          kind,
        })}
      />

      <Text my={10} fontSize={'2xl'}>
        {product.price} €
      </Text>

      {product.videoId && <YouTubeWrapper videoId={product.videoId} />}

      <Text my={10} fontSize={'xl'}>
        {product.description}
      </Text>

      {product.products && (
        <Text my={10} fontSize={'xl'}>
          Composizione
        </Text>
      )}
      {product.products &&
        product.products.map((item, index) => <div key={index}>{item.title}</div>)}

      <Button my={10} as={Link} to='/menu'>
        Torna al menù
      </Button>
      <Footer />
    </Box>
  );
}

export default ProductDetail;
